<div class="_wf-pp-slotdiv" [ngStyle]="hasAppliedCss? checkStyle():''">
    <div class="_wf-pp-morningslot" *ngIf="timeSlots.length > 0 && cheklength() && !checkTypeOfTimeSlots(timeSlots)">
        <!-- div changed to button for testing -->
        <ng-template #slotTimingInfoContainer>
            <div>{{timing.slot_start_time | date: 'hh:mm a'}} - {{timing.slot_end_time | date: 'hh:mm a'}}</div>
        </ng-template>
        <button class="_wf-pp-timebox" *ngFor="let slot of timeSlots"
            id="selected_slot{{slot['id']}}{{slot['slot_start_time']}}" (click)="setAppointment(slot)"
            [ngClass]="(slot.status !== 'available') || (slot.slot_end_time < currentTime) ?'_wf-pp-selected':'_wf-pp-available 1'"
            [ngStyle]="((slot.status != 'available') || (slot.slot_end_time < currentTime) ? {'cursor':'not-allowed'}:autoSelectedSlots!=undefined && autoSelectedSlots.service_start_time!=undefined && slot.slot_end_time == autoSelectedSlots.service_start_time ? {'background':'#5CBAF1'}:'')"
            [popover]="slotTimingInfo?slotTimingInfoContainer:''" placement="bottom" triggers="mouseenter:mouseleave"
            (mouseover)="onHoverSlotTiming(slot)">
            <div>
                {{slot[key] | date: 'hh:mm a'}} <i *ngIf="slot.slot_visibility == 'Offline'" class="fa fa-circle"
                    style="color: #d6d6d6;" aria-hidden="true"></i>
            </div>
        </button>
    </div>
    <div class="_wf-pp-morningslot" *ngIf="cheklength() && checkTypeOfTimeSlots(timeSlots)">
        <!-- div changed to button for testing -->
        <!-- {{timeSlots|json}} -->
        <ng-container *ngFor="let s of timeSlots | keyvalue: originalOrder">
            <div class="w-100 pb-2 pl-2 font-weight-bold">{{s.key | translate | async}}</div>
            <ng-container *ngFor="let p of s.value | keyvalue: originalOrder">
                <div class="w-100 pb-2 pl-2 font-weight-bold">{{p.key | translate | async}}</div>
                <button class="_wf-pp-timebox" *ngFor="let slot of p.value"
                    id="selected_slot{{slot['id']}}{{slot['slot_start_time']}}" (click)="setAppointment(slot)"
                    [ngClass]="(slot.status !== 'available') || (slot.slot_end_time < currentTime) ?'_wf-pp-selected':'_wf-pp-available 2'"
                    [ngStyle]="getAppointmentModeCss(slot)" [ngStyle]="(slot.status != 'available') || (slot.slot_end_time < currentTime) ? {'cursor':'not-allowed'}: '' ">
                    <div>
                        {{slot[key] | date: 'hh:mm a'}} <i *ngIf="slot.slot_visibility == 'Offline'"
                            class="fa fa-circle" style="color: #d6d6d6;" aria-hidden="true"></i>
                        <ng-container
                            *ngIf="slot.status == 'available' && (slot.slot_end_time > currentTime) && slot.reason == undefined && slot.still_available">
                            ({{slot.still_available}})
                        </ng-container>
                    </div>
                </button>
            </ng-container>

            <!--  -->
        </ng-container>
    </div>

    <div class="_wf-pp-morningslot" *ngIf="timeSlots.length > 0 && !cheklength() && !checkTypeOfTimeSlots(timeSlots)">
        <ng-template #getpatientDetails>
            <i class="fa fa-circle-o-notch fa-spin" style="font-size:24px" *ngIf="showSpinner"></i>
            <span *ngIf="patientDetail && patientDetail.length > 0 && !showSpinner && !hideToolTip">
                <div *ngFor="let p of patientDetail;let i= index"><span>{{i+1}}.</span>
                    {{p.patient_name}}, {{p.patient_age}}/{{p.patient_gender}}
                    ({{p.payer_name}})</div>
            </span>
            <span *ngIf="patientDetail && patientDetail.length == 0 && !showSpinner">
                <div>{{status}}</div>
            </span>
        </ng-template>
        <span *ngIf="checkPermission()" class="slots-container-mobile">
            <button class="_wf-pp-timebox"
                [ngClass]="slot.status == 'available' && (slot.slot_end_time > currentTime) ?'_wf-pp-available 3':''"
                *ngFor="let slot of timeSlots" id="selected_slot{{slot['id']}}{{slot['slot_start_time']}}"
                (click)="setAppointment(slot)" [ngStyle]="applyStyle(slot)"
                [popover]="!hideToolTip?getpatientDetails:''" placement="bottom" triggers="mouseenter:mouseleave"
                (mouseover)="onHover(slot)">
                <div>
                    {{slot[key] | date: 'hh:mm a'}} <i *ngIf="slot.slot_visibility == 'Offline'" class="fa fa-circle"
                        style="color: #d6d6d6;" aria-hidden="true"></i>
                </div>
            </button>
        </span>
        <span *ngIf="!checkPermission()">
            <button class="_wf-pp-timebox"
                [ngClass]="slot.status == 'available' && (slot.slot_end_time > currentTime) ?'_wf-pp-available 4':''"
                *ngFor="let slot of timeSlots" id="selected_slot{{slot['id']}}{{slot['slot_start_time']}}"
                (click)="setAppointment(slot)" [ngStyle]="applyStyle(slot)">
                <div>
                    {{slot[key] | date: 'hh:mm a'}} <i *ngIf="slot.slot_visibility == 'Offline'" class="fa fa-circle"
                        style="color: #d6d6d6;" aria-hidden="true"></i>

                </div>
            </button>
        </span>
    </div>

    <div class="_wf-pp-morningslot" *ngIf="!cheklength() && checkTypeOfTimeSlots(timeSlots)">
        <ng-template #getpatientDetails>
            <i class="fa fa-circle-o-notch fa-spin" style="font-size:24px" *ngIf="showSpinner"></i>
            <span *ngIf="patientDetail && patientDetail.length > 0 && !showSpinner && !hideToolTip">
                <div *ngFor="let p of patientDetail;let i= index"><span>{{i+1}}.</span>
                    {{p.uhId}} {{p.patient_name}}, {{p.patient_age}}/{{p.patient_gender}}
                    <ng-container *ngIf="p.telecom">,{{p.telecom}}</ng-container>
                    <ng-container *ngIf="p.care_type_name"> ,{{p.care_type_name}}</ng-container>
                </div>
                <div *ngIf="status != 'Not Available'">{{status}}</div>
            </span>
            <span *ngIf="patientDetail && patientDetail.length == 0 && !showSpinner">
                <div>{{status}}</div>
            </span>
        </ng-template>
        <span *ngIf="checkPermission()" class="slots-container-mobile">
            <ng-container *ngFor="let s of timeSlots | keyvalue: originalOrder">
                <div class="w-100 pb-2 pl-2 font-weight-bold">{{s.key | translate | async}}</div>
                <!-- {{s.value | json}} -->
                <ng-container *ngFor="let p of s.value | keyvalue: originalOrder">
                    <div class="w-100 pb-2 pl-2 font-weight-bold"> {{p.key | translate | async}}</div>
                    <button class="_wf-pp-timebox" *ngFor="let slot of p.value"
                        [ngClass]="slot.status == 'available' && (slot.slot_end_time > currentTime) ?'_wf-pp-available 5':''"
                        id="selected_slot{{slot['id']}}{{slot['slot_start_time']}}" (click)="setAppointment(slot)"
                        [ngStyle]="applyStyle(slot)" [ngStyle]="getAppointmentModeCss(slot)" [popover]="!hideToolTip?getpatientDetails:''" placement="bottom"
                        triggers="mouseenter:mouseleave" (mouseover)="onHover(slot)">
                        <div>
                            <span *ngIf="!slot.waiting_booking">{{slot[key] | date: 'hh:mm a'}}</span> <i
                                *ngIf="slot.slot_visibility == 'Offline'" class="fa fa-circle" style="color: #d6d6d6;"
                                aria-hidden="true"></i>
                            <ng-container
                                *ngIf="slot.waiting_booking && slot.status == 'available' && (slot.slot_end_time > currentTime) && slot.reason == undefined">
                                WT-{{slot.still_available}}</ng-container>
                            <ng-container
                                *ngIf="slot.waiting_booking && slot.status == 'booked' && (slot.slot_end_time > currentTime) && slot.reason == undefined">
                                WT-0</ng-container>
                            <ng-container
                                *ngIf="(slot.doctor_over_booking_status || slot.last_slot_overbooking || slot.over_booking) && slot.status == 'available' && (slot.slot_end_time > currentTime) && slot.reason == undefined">
                                ({{slot.still_available}})</ng-container>
                        </div>
                    </button>
                </ng-container>
            </ng-container>
        </span>
        <span *ngIf="!checkPermission()">
            <ng-container *ngFor="let s of timeSlots | keyvalue: originalOrder">
                <div class="w-100 pb-2 pl-2 font-weight-bold">{{s.key | translate | async}}</div>
                <ng-container *ngFor="let p of s.value | keyvalue: originalOrder">
                    <div class="w-100 pb-2 pl-2 font-weight-bold"> {{p.key | translate | async}}</div>
                    <button class="_wf-pp-timebox"
                        [ngClass]="slot.status == 'available' && (slot.slot_end_time > currentTime) ?'_wf-pp-available 6':''"
                        *ngFor="let slot of p.value" id="selected_slot{{slot['id']}}{{slot['slot_start_time']}}"
                        (click)="setAppointment(slot)" [ngStyle]="applyStyle(slot)">
                        <div>
                            {{slot[key] | date: 'hh:mm a'}} <i *ngIf="slot.slot_visibility == 'Offline'"
                                class="fa fa-circle" style="color: #d6d6d6;" aria-hidden="true"></i>
                        </div>
                    </button>
                </ng-container>
            </ng-container>
        </span>
    </div>

    <div class="row" *ngIf="timeSlots.length==0">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <h5 class="text-center p-1" *ngIf="errorMessage == undefined">{{'field.hint.no_slot_found' |
                        translate | async}}</h5>
                    <h5 class="text-center p-1" *ngIf="errorMessage != undefined">{{errorMessage}}</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="checklenghtOfEmr(timeSlots)">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <h5 class="text-center p-1" *ngIf="errorMessage == undefined">{{'field.hint.no_slot_found' |
                        translate | async}}</h5>
                    <h5 class="text-center p-1" *ngIf="errorMessage != undefined">{{errorMessage}}</h5>
                </div>
            </div>
        </div>
    </div>
</div>